import React, { useEffect, useRef, useState } from 'react';
import userImage from '../assets/user.png'
import { useNavigate } from "react-router-dom";
import '../App.css'
import './profilePhoto.css'
import LogOutIcon from '../assets/LogoutIcon.svg';
import axios from 'axios';
import { resolveShortId } from '../utils/userIdentity';

const ProfilePhoto = ({ translate }) => {
    const [profileImage, setProfileImage] = useState(null);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [userName, setUserName] = useState('');
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleLogout = () => {
        // Save tour completion status before clearing
        const tourCompleted = localStorage.getItem('productTourCompleted');

        // Clear all session storage and local storage
        sessionStorage.removeItem('authCompleted');
        sessionStorage.clear();
        localStorage.clear();

        // Restore tour completion status
        if (tourCompleted) {
            localStorage.setItem('productTourCompleted', tourCompleted);
        }

        // Redirect to oauth2-proxy sign_out endpoint
        // oauth2-proxy will:
        // 1. Delete the _oauth2_proxy cookie
        // 2. Optionally notify Microsoft to end the SSO session
        // 3. Redirect back to the specified redirect URL (rd parameter)
        window.location.href = `/oauth2/sign_out?rd=${encodeURIComponent('/login')}`;
    };

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                // Fetch user info from oauth2-proxy userinfo endpoint
                const response = await axios.get('/oauth2/userinfo');
                const data = response.data;
                // Prefer a claim that is a REAL email (Microsoft OIDC sets preferred_username/
                // email to the user's email) and take its local part → canonical short ID.
                // CIAM B2C maps email→GUID, so fall back to data.user (its bare short ID),
                // but never to a GUID/opaque value.
                const shortId = resolveShortId(data);
                if (shortId) {
                    localStorage.setItem('userinfo', shortId.toLowerCase());
                    setUserName(shortId.toUpperCase());
                }
            } catch (error) {
                console.error('Error fetching user info:', error);
                // Fall back to sessionStorage if API call fails
                const storedEmail = localStorage.getItem('userinfo');
                if (storedEmail) {
                    const nameBeforeAt = storedEmail.split('@')[0].toUpperCase();
                    setUserName(nameBeforeAt);
                }
            }
        };

        fetchUserInfo();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div ref={dropdownRef}>
            <div className="dropdown custom-dropdown">
                <div
                    className="profile-container"
                    role="button"
                    onClick={toggleDropdown}
                >
                    <img className="profile-image" src={profileImage ? profileImage : userImage} alt="Profile" />
                    <span className="profile-name">{userName}</span>
                    <svg 
                        className={`chevron-icon ${isOpen ? 'rotated' : ''}`}
                        width="20" 
                        height="20" 
                        viewBox="0 0 20 20" 
                        fill="none"
                    >
                        <path 
                            d="M5 7.5L10 12.5L15 7.5" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                {isOpen && (
                    <ul className="dropdown-menu custom-dropdown-menu">
                        <li onClick={() => handleLogout()}>
                            <div className="dropdown-item custom-dropdown-item font-family">
                                <img src= {LogOutIcon} alt="logOutIcon" />
                                {translate("Logout")}
                            </div>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ProfilePhoto;